import React, { createContext, useContext, useState } from 'react'

class Comments {
  constructor ({ commentSidebarOpenState, commentBlockIdState, commentPagePropertyState, showResolvedState }) {
    const [commentSidebarOpen, setCommentSidebarOpen] = commentSidebarOpenState
    this.commentSidebarOpen = commentSidebarOpen
    this.setCommentSidebarOpen = setCommentSidebarOpen

    const [commentBlockId, setCommentBlockId] = commentBlockIdState
    this.commentBlockId = commentBlockId
    this.setCommentBlockId = setCommentBlockId

    const [commentPageProperty, setCommentPageProperty] = commentPagePropertyState
    this.commentPageProperty = commentPageProperty
    this.setCommentPageProperty = setCommentPageProperty

    // Helper functions
    this.closeCommentSidebar = () => setCommentSidebarOpen(false)
    this.openCommentSidebar = () => setCommentSidebarOpen(true)

    const [showResolved, setShowResolved] = showResolvedState
    this.showResolved = showResolved

    this.revealResolved = () => setShowResolved(true)
    this.hideResolved = () => setShowResolved(false)

    this.openBlockComments = (blockId) => {
      this.openCommentSidebar()
      setCommentPageProperty(null)
      setCommentBlockId(blockId)
    }
    this.openPagePropertyComments = (pageProperty) => {
      this.openCommentSidebar()
      setCommentPageProperty(pageProperty)
      setCommentBlockId(null)
    }
  }

  getCommentSidebarOpen () {
    return this.commentSidebarOpen
  }
}

const CommentContext = createContext()

export const useCommentContext = function () {
  return useContext(CommentContext)
}

export const CommentContextProvider = function ({ children }) {
  const commentSidebarOpenState = useState(false)
  const commentBlockIdState = useState(null)
  const commentPagePropertyState = useState(null)
  const showResolvedState = useState(false)
  const commentData = new Comments({ commentSidebarOpenState, commentBlockIdState, commentPagePropertyState, showResolvedState })

  return (
    <CommentContext.Provider value={commentData}>
      {children}
    </CommentContext.Provider>
  )
}
